/**
 * dashboardLoader.js. DO NOT apply var to these values. The vars file has not loaded yet.
 * Created by calhosh on 9/22/2020.
 */
import React from 'react';
import styled from 'styled-components';
import Skeleton from 'react-loading-skeleton';

const DashBoardSkeletonLoader = styled.section`
	overflow: hidden;
	background: var(--neutrals-200);

	.main-wrapper {
		display: flex;
		align-items: stretch;
		height: calc(100vh - 6rem);
	}

	.cards-wrapper {
		display: flex;
		width: 100%;
		align-items: center;
		justify-content: space-between;
		margin: 1rem 0;
	}

	.milestones-wrapper {
		background: var(--neutrals-00white);
		padding: 2rem 4rem;
		.header {
			width: 12%;
			height: 4rem;
			display: flex;
			margin-bottom: 2rem;
		}

		.row-2 {
			display: flex;
			align-items: center;
			justify-content: space-between;
			width: 100%;

			.row-inner1,
			.row-inner2 {
				display: flex;
				align-items: center;
				justify-content: space-between;

				.row-content {
					width: 100%;
					height: 4rem;
					display: flex;
					margin-right: 1rem;
				}
			}
			.row-inner1 {
				width: 38.5%;
			}
			.row-inner2 {
				width: 35%;
				.row-content {
					margin-right: 0;
				}
			}
		}
		.time-phase-wrap {
			display: flex;
			width: 100%;
			margin-top: 2rem;
			align-items: center;
			justify-content: space-between;
			.time-phase-title {
				width: 20%;
				height: 2rem;
				display: flex;
			}
			.time-phase-content {
				width: 78%;
				height: 2rem;
				display: flex;
			}
		}

		.header,
		.time-phase-content,
		.time-phase-title,
		.row-content {
			& > span {
				width: 100%;
				height: 100%;
				line-height: normal;
			}
		}
	}
`;

const Profile = styled.section`
	background: var(--neutrals-00white);
	padding: 1rem;
	border: 0.1rem solid var(--neutrals-300);
	margin-top: 1rem;
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
	height: 10%;
	.engName {
		width: 50%;
		height: 100%;
		display: flex;
		align-items: center;
	}
	.profile-pic {
		display: flex;
		line-height: normal;
		align-items: center;
		justify-content: center;
		width: 4%;
		height: 100%;
		@media screen and (max-width: 1280px) {
			width: 3.5%;
		}
	}

	&.eng-overview {
		.eng-overview-inner {
			width: 30%;
			height: 100%;
			display: flex;
			align-items: center;
		}
	}
	.engName,
	.profile-pic,
	.eng-overview-inner {
		& > span {
			width: 100%;
			height: 100%;
			line-height: normal;
		}
	}
`;

const StyledLeftSection = styled.section`
	width: 10%;
	display: flex;
	flex-direction: column;
	padding-top: 1rem;
	margin: 1rem 1rem 1rem 0rem;
	align-items: center;
	span {
		width: 35%;
		height: 7%;
		display: flex;
		align-items: center;
		margin-bottom: 1rem;
		margin-top: 1rem;
	}
`;

const StyledRightSection = styled.section`
	width: 90%;
`;

const StyledCardSection = styled.section`
	width: 32.5%;
	background: var(--neutrals-00white);
	padding: 2rem 4rem;
	border: 0.1rem solid var(--neutrals-300);

	.header {
		width: 40%;
		height: 4rem;
		display: flex;
		margin-bottom: 2rem;
	}
	.description {
		width: 100%;
		height: 3rem;
		display: flex;
		margin-bottom: 2rem;
	}
	.content {
		display: flex;
		align-items: center;
		justify-content: space-between;
		height: 15rem;
		.content-inner {
			width: 45%;
			height: 100%;
		}
	}
	.header,
	.description,
	.content-inner {
		& > span {
			width: 100%;
			height: 100%;
			line-height: normal;
		}
	}
`;

const dashBoardSkeletonLoader = (props) => {
	return (
		<DashBoardSkeletonLoader>
			<section className="main-wrapper mainResponsiveWrapper">
				<StyledLeftSection></StyledLeftSection>
				<StyledRightSection>
					<Profile className="profile">
						<section className="profile-pic">
							<Skeleton circle={true} height={'100%'} width={'100%'} />
						</section>
						<section className="engName">
							<Skeleton circle={false} height={'100%'} width={'100%'} />
						</section>
					</Profile>
					<Profile className="eng-overview">
						<section className="eng-overview-inner">
							<Skeleton circle={false} height={'100%'} width={'100%'} />
						</section>
					</Profile>
					<section className="cards-wrapper">
						<StyledCardSection className="card-item">
							<section className="header">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="description">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="content">
								<section className="content-inner">
									<Skeleton circle={false} height={'100%'} width={'100%'} />
								</section>
								<section className="content-inner">
									<Skeleton circle={false} height={'100%'} width={'100%'} />
								</section>
							</section>
						</StyledCardSection>
						<StyledCardSection className="card-item">
							<section className="header">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="description">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="content">
								<section className="content-inner">
									<Skeleton circle={false} height={'100%'} width={'100%'} />
								</section>
								<section className="content-inner">
									<Skeleton circle={false} height={'100%'} width={'100%'} />
								</section>
							</section>
						</StyledCardSection>
						<StyledCardSection className="card-item">
							<section className="header">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="description">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="content">
								<section className="content-inner">
									<Skeleton circle={false} height={'100%'} width={'100%'} />
								</section>
								<section className="content-inner">
									<Skeleton circle={false} height={'100%'} width={'100%'} />
								</section>
							</section>
						</StyledCardSection>
					</section>
					<section className="milestones-wrapper">
						<section className="header">
							<Skeleton circle={false} height={'100%'} width={'100%'} />
						</section>
						<section className="row-2">
							<section className="row-inner1">
								<section className="row-content">
									<Skeleton circle={false} height={'100%'} width={'100%'} />
								</section>
								<section className="row-content">
									<Skeleton circle={false} height={'100%'} width={'100%'} />
								</section>
								<section className="row-content">
									<Skeleton circle={false} height={'100%'} width={'100%'} />
								</section>
							</section>
							<section className="row-inner2">
								<section className="row-content">
									<Skeleton circle={false} height={'100%'} width={'100%'} />
								</section>
							</section>
						</section>
						<section className="time-phase-wrap">
							<section className="time-phase-title">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="time-phase-content">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
						</section>
						<section className="time-phase-wrap">
							<section className="time-phase-title">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="time-phase-content">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
						</section>
						<section className="time-phase-wrap">
							<section className="time-phase-title">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="time-phase-content">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
						</section>
						<section className="time-phase-wrap">
							<section className="time-phase-title">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="time-phase-content">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
						</section>
						<section className="time-phase-wrap">
							<section className="time-phase-title">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="time-phase-content">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
						</section>
						<section className="time-phase-wrap">
							<section className="time-phase-title">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
							<section className="time-phase-content">
								<Skeleton circle={false} height={'100%'} width={'100%'} />
							</section>
						</section>
					</section>
				</StyledRightSection>
			</section>
		</DashBoardSkeletonLoader>
	);
};

export default dashBoardSkeletonLoader;
